<template>
    <div id="fUser" v-loading.fullscreen.lock="visible.loading" element-loading-background="rgba(0, 0, 0, 0.4)">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 系统管理</el-breadcrumb-item>
                <el-breadcrumb-item>用户管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container" v-if="power.search">
            <div class="handle-box left">
                <el-input v-model="data.filterstr" placeholder="筛选关键词(用户名称)" class="handle-input mr10" size="large"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="search" v-if="power.search">搜索</el-button>
            </div>
            <div class="handle-box right">
                <el-button type="primary" @click="toAdd" v-if="power.add">
                    <i class="el-icon-lx-roundadd"></i>新增
                </el-button>
                <el-button type="danger" @click="toDelete" :disabled="data.selections.length==0" class="mr10" v-if="power.delete">
                    <i class="el-icon-delete"></i>删除
                </el-button>
                <!--<el-button type="primary" @click="toRole" :disabled="data.selections.length==0" class="mr10">
                    <i class="el-icon-s-custom"></i>分配角色
                </el-button>-->
            </div>
            <el-table ref="table" :data="data.rows" border class="table" row-key="roleid" @selection-change="handleSelectionChange"
                @cell-click="handleCellClick">
                <el-table-column type="selection" width="40" :selectable="enableSelection">
                </el-table-column>
                <el-table-column prop="userName" label="登陆ID" width="120" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="nickName" label="用户名称" width="160" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="enable" label="有效" width="100">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.enable">有效</el-tag>
                        <el-tag type="danger" v-else>无效</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="crTime" label="创建时间" width="260">
                </el-table-column>
                <!--<el-table-column prop="Creator" label="创建人" width="100">
                </el-table-column>-->
                <el-table-column prop="modTime" label="修改时间" width="260">
                </el-table-column>
                <!--<el-table-column prop="Modifier" label="修改人" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.Modifier">{{scope.row.Modifier}}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>-->
                <el-table-column prop="opt" label="操作" width="800" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" icon="el-icon-edit" @click="toEdit(scope.row)" v-if="scope.row.id != 1 && power.edit">修改</el-button>
                        <el-button v-if="scope.row.id != 1 && power.disable && scope.row.enable" size="mini" type="danger" icon="el-icon-delete" @click="doEnable(scope.row.id,false)">停用</el-button>
                        <el-button v-else-if="scope.row.id != 1 && power.enable && !scope.row.enable" size="mini" type="primary" icon="el-icon-delete" @click="doEnable(scope.row.id,true)">启用</el-button>
                        <el-button size="mini" type="danger" icon="el-icon-delete" @click="toDelete([scope.row])" v-if="scope.row.id != 1 && power.delete">删除</el-button>
                        <el-button size="mini" type="primary" icon="el-icon-s-custom" @click="toDept(scope.row)" v-if="scope.row.id != 1 && power.allotDept">部门分配</el-button>
                        <el-button size="mini" type="primary" icon="el-icon-s-custom" @click="toRole(scope.row)" v-if="scope.row.id != 1 && power.allotRole">角色分配</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentPageChange" :current-page="data.page"
                    :page-sizes="[10,20,50,100,200,300,400,500]" :page-size="data.size" layout="total, sizes, prev, pager, next, jumper"
                    :total="data.total">
                </el-pagination>
            </div>
        </div>

        <!-- 新增/编辑弹出框 -->
        <el-dialog :title="data.info.type" :visible.sync="visible.info" width="500px" :close-on-press-escape="false"
            :close-on-click-modal="false">
            <el-form ref="infoDialog" :model="data.info" label-width="130px">
                <el-form-item label="登陆ID:">
                    <el-input v-model="data.info.userName" size="large"></el-input>
                </el-form-item>
                <el-form-item label="用户名称:">
                    <el-input v-model="data.info.nickName" size="large"></el-input>
                </el-form-item>
                <el-form-item label="登陆密码:">
                    <el-input v-model="data.info.password" :placeholder="data.info.placeholder" show-password size="large"></el-input>
                </el-form-item>
                <el-form-item label="是否有效:">
                    <el-switch v-model="data.info.enable" active-color="green" inactive-color="gray">
                    </el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveInfo">确 定</el-button>
                <el-button @click="clearAndCloseInfo">取 消</el-button>
            </span>
        </el-dialog>

        <!-- 删除提示框 -->
        <el-dialog title="提示" :visible.sync="visible.del" width="300px" center :close-on-press-escape="false"
            :close-on-click-modal="false">
            <div class="del-dialog-cnt">
                正在删除用户:
                <template v-for="item in data.rowsToDelete">
                    {{ item.nickName }}({{ item.userName }})、
                </template>
                删除不可恢复，是否确定删除？
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="deleteRow">确 定</el-button>
                <el-button @click="visible.del = false">取 消</el-button>
            </span>
        </el-dialog>

        <!-- 分配角色 -->
        <el-dialog :title="data.info.type" :visible.sync="visible.role" width="240px" :close-on-press-escape="false"
            :close-on-click-modal="false">
			<div>
                <el-checkbox v-for="role in data.roles" :label="role.label" :key="role.id" v-model="role.checked" size="medium" style="width:120px;"></el-checkbox>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveRole">确 定</el-button>
                <el-button @click="visible.role = false">取 消</el-button>
            </span>
        </el-dialog>

        <!-- 分配部门 -->
        <el-dialog title="分配部门" :visible.sync="visible.dept" width="450px" :close-on-press-escape="false"
            :close-on-click-modal="false">
            <el-checkbox v-model="data.allDept">拥有所有部门权限</el-checkbox>
            <div :style="{display: data.allDept ? 'none':'block'}">
                <el-tree ref="depts" :data="data.depts" show-checkbox node-key="id" default-expand-all>
                </el-tree>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveDept">确 定</el-button>
                <el-button @click="visible.dept = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'usermanage',
        data() {
            return {
                data: {
                    filterstr: '',
                    total: 0,
                    size: 100,
                    page: 1,
                    rows: [],
                    selections: [],
                    rowsToDelete: [],
                    info: {
                        type: 'add',
                        id: 0,
                        userName: '',
                        nickName: '',
                        password: '',
                        enable: true,
						placeholder: '默认密码123456'
                    },
                    roles: [],
                    depts: [],
					allDept: false
                },
                visible: {
                    info: false,
                    role: false,
                    dept: false,
                    del: false,
                    loading: false
                },
                power: {
                    pageId: 12,
                    search: false,
                    add: false,
                    edit: false,
                    delete: false,
					allotRole: false,
					allotDept: false,
					enable: false,
					disable: false
                }
            }
        },
        methods: {
			enableSelection(r, idx) {
				return r.id != 1;
			},
            search(change) {
                let vue = this;
                vue.visible.loading = true;
                if (change) {
                    vue.data.page = 1;
                }
				window.ax.get('api/system/user/list?pagesize=' + vue.data.size + '&currentpage=' + vue.data.page + '&sign=' + window.$gloable.userinfo.sign + '&filterStr=' + vue.data.filterstr, {}).then(rsp => {
                    let data = rsp.data;
                    if (data.code == 1) {
                        data = data.data;
                        let len = data.datas.length;
                        let total = data.totalRecord;
                        vue.data.rows = data.datas;
                        vue.data.total = total;
                        if (len == 0 && total > 0) {
                            vue.data.page = Math.ceil(total / vue.data.size);
                            vue.search();
                        }
                    } else {
                        vue.$message.error(data.message);
                    }
                    vue.visible.loading = false;
                }).catch(err => {
                    vue.$message.error('执行脚本出错，请联系管理员');
                    console.log(err);
                    vue.visible.loading = false;
                });
            },
            handleSizeChange(size) {
                this.data.size = size;
                this.search(true);
            },
            handleCurrentPageChange(current) {
                this.data.page = current;
                this.search();
            },
            toAdd() {
                this.data.info.type = '新增';
                this.data.info.id = 0;
                this.data.info.enable = true;
                this.data.info.userName = '';
                this.data.info.nickName = '';
                this.data.info.password = '';
				this.data.info.placeholder = '默认密码123456';
                this.visible.info = true;
            },
            toEdit(row) {
                let vue = this;
                window.ax.get('api/system/user/info?sign=' + window.$gloable.userinfo.sign + '&id=' + row.id, { }).then(rsp => {
                    let data = rsp.data;
                    if (data.code == 1) {
                        vue.data.info = data.data;
						vue.data.info.placeholder = '填写新密码修改密码';
                        vue.data.info.type = '修改 - ' + row.nickName;
                        vue.visible.info = true;
                    } else {
                        vue.$message.error(data.Message);
                    }
                }).catch(err => {
                    this.$message.error('执行脚本出错，请联系管理员');
                    console.log(err);
                    vue.visible.loading = false;
                });
            },
            toRole(row) {
                let vue = this;
                vue.visible.loading = true;
                row = row ? row : vue.data.selections[0];
                window.ax.get('api/system/userrole?sign=' + window.$gloable.userinfo.sign + '&id=' + row.id).then(rsp => {
                    let data = rsp.data;
                    if (data.code == 1) {
                        vue.data.info = row;
                        vue.data.info.type = '分配角色 - ' + row.nickName;
                        vue.data.roles = data.data;
                        vue.visible.role = true;
                    } else {
                        vue.$message.error(data.message);
                    }
                    vue.visible.loading = false;
                }).catch(err => {
                    vue.$message.error('执行脚本出错，请联系管理员');
                    console.log(err);
                    vue.visible.loading = false;
                });
            },
            toDept(row) {
                let vue = this;
                vue.data.info.type = '分配部门 - ' + row.nickName;
                vue.visible.loading = true;
                row = row ? row : vue.data.selections[0];
                vue.data.info = row;
                window.ax.get('api/system/userdept?sign=' + window.$gloable.userinfo.sign + '&id=' + row.id).then(rsp => {
                    let data = rsp.data;
                    if (data.code == 1) {
						data = data.data;
						vue.data.depts = data.depts;
                        if (typeof(data.curDepts) == "boolean") {
                            vue.data.allDept = true;
                            if (vue.$refs.depts) {
                                vue.$refs.depts.setCheckedKeys([]);
                            } else {
                                setTimeout(function() {
                                    vue.$refs.depts.setCheckedKeys([]);
                                }, 100);
                            }
                        } else {
                            vue.data.allDept = false;
                            if (vue.$refs.depts) {
                                vue.$refs.depts.setCheckedKeys(data.curDepts);
                            } else {
                                setTimeout(function(d) {
                                    vue.$refs.depts.setCheckedKeys(d);
                                }, 100, data.curDepts);
                            }
                        }
                        vue.visible.dept = true;
                    } else {
                        vue.$message.error(data.message);
                    }
                    vue.visible.loading = false;
                }).catch(err => {
                    vue.$message.error('执行脚本出错，请联系管理员');
                    console.log(err);
                    vue.visible.loading = false;
                });
            },
            toDelete(row) {
                if (Array.isArray(row)) {
                    this.data.rowsToDelete = row;
                } else {
                    this.data.rowsToDelete = this.data.selections;
                }
                this.visible.del = true;
            },
            saveInfo() {
                let vue = this;
                var inf = vue.data.info;
                let opt = {
                    Sign: window.$gloable.userinfo.sign,
                    id: inf.id,
                    UserName: inf.userName,
                    NickName: inf.nickName,
                    Password: inf.password,
                    Enable: inf.enable,
					ChangeFlag: 0
                };
                window.ax.post('api/system/user/save', opt).then(rsp => {
                    let data = rsp.data;
                    if (data.code == 1) {
                        vue.search();
                        vue.clearAndCloseInfo();
                        vue.$message.success('保存成功');
                    } else {
                        this.$message.error(data.message);
                    }
                    vue.visible.loading = false;
                }).catch(err => {
                    vue.$message.error('执行脚本出错，请联系管理员');
                    console.log(err);
                    vue.visible.loading = false;
                });
            },
			doEnable(id, status) {
				let vue = this;
				vue.visible.loading = true;
				window.ax.post('api/system/user/save', {
					Sign: window.$gloable.userinfo.sign,
					Id: id,
					ChangeFlag: status ? 2 : 1
				}).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						vue.search();
						vue.clearAndCloseInfo();
						vue.$message.success((status ? '停用' : '启用') + '成功');
					} else {
						vue.$message.error(data.Message);
					}
					vue.visible.loading = false;
				}).catch(err => {
					vue.$message.error('执行脚本出错，请联系管理员');
					vue.visible.loading = false;
				});
			},
            clearAndCloseInfo() {
                this.visible.info = false;
                this.data.info.id = 0;
                this.data.info.enable = true;
                this.data.info.userName = '';
                this.data.info.nickName = '';
                this.data.info.password = '';
            },
            saveRole() {
                let vue = this;
                vue.visible.loading = true;
                let ids = '';
                let len = vue.data.roles.length;
                for (let i = 0; i < len; i++) {
                    var role = vue.data.roles[i];
                    if (role.checked) {
                        ids += (role.id + ',');
                    }
                }
                if (ids.length > 0) {
                    ids = ids.substring(0, ids.length - 1);
                }
                window.ax.post('api/system/userrole/save', {
                    Sign: window.$gloable.userinfo.sign,
                    Id: vue.data.info.id,
                    RoleIds: ids
                }).then(rsp => {
                    let data = rsp.data;
                    if (data.code == 1) {
                        vue.$message.success('保存成功');
                    } else {
                        vue.$message.error(data.message);
                    }
                    vue.visible.role = false;
                    vue.visible.loading = false;
                }).catch(err => {
                    vue.$message.error('执行脚本出错，请联系管理员');
                    console.log(err);
                    vue.visible.loading = false;
                });
            },
            saveDept() {
                let vue = this;
                vue.visible.loading = true;
                let ids = '';
                ids = vue.data.allDept ? '1' : '0';
                if (!vue.data.allDept) {
                    let dids = vue.$refs.depts.getCheckedKeys();
                    let len = dids.length;
                    for (let i = 0; i < len; i++) {
                        ids += (dids[i] + ',');
                    }
                    if (len > 0) {
                        ids = ids.substring(0, ids.length - 1);
                    }
                }
                window.ax.post('api/system/userdept/save', {
                    Sign: window.$gloable.userinfo.sign,
                    Id: vue.data.info.id,
                    DeptIds: ids,
					AllDept: vue.data.allDept
                }).then(rsp => {
                    let data = rsp.data;
                    if (data.code == 1) {
                        vue.$message.success('保存成功');
                    } else {
                        vue.$message.error(data.message);
                    }
                    vue.visible.dept = false;
                    vue.visible.loading = false;
                }).catch(err => {
                    vue.$message.error('执行脚本出错，请联系管理员');
                    console.log(err);
                    vue.visible.loading = false;
                });
            },
            deleteRow() {
                let vue = this;
                vue.visible.loading = true;
                let len = vue.data.rowsToDelete.length;
                if (len > 0) {
					let ids = [];
					for (var i = 0; i < len; i++) {
						var r = vue.data.rowsToDelete[i];
						ids.push(r.id);
					}
                    window.ax.post('api/system/user/Delete', {
                        Sign: window.$gloable.userinfo.sign,
                        ids: ids
                    }).then(rsp => {
                        let data = rsp.data;
                        if (data.code == 1) {
                            vue.search();
                            vue.$message.success('删除成功');
							vue.visible.del = false;
                        } else {
                            vue.$message.error(data.Message);
                        }
                        vue.visible.loading = false;
                    }).catch(err => {
                        vue.$message.error('执行脚本出错，请联系管理员');
                        console.log(err);
                        vue.visible.loading = false;
                    });
                }
            },
            handleSelectionChange(selections) {
                this.data.selections = selections;
            },
            handleCellClick(row, column, cell, event) {
                if (row.id != 1 && column.property != 'opt') {
                    this.$refs.table.toggleRowSelection(row, this.data.selections.indexOf(row) == -1);
                }
            }
        },
        created() {
			this.baseJS.initPower(this.power);
            this.search();
        },
        mounted() {}
    }
</script>

<style scoped>
    .is-current {
        background: #cccccc;
    }

    .handle-box {
        margin-bottom: 20px;
    }

    .left {
        float: left;
    }

    .right {
        float: right;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .del-dialog-cnt {
        font-size: 16px;
        text-align: center
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .mr10 {
        margin-right: 10px;
    }

    .m10 {
        margin: 10px;
    }

    .mt1 {
        margin-top: 1px;
    }

    .fr {
        float: right;
    }

    .form-warp {
        position: relative;
        width: 560px;
        height: 520px;
        padding-left: 200px;
        border: 1px solid #ccc;
    }

    .form-warp-left {
        position: absolute;
        left: 0;
        top: 0;
        width: 200px;
        height: 492px;
        padding-top: 28px
    }

    .department-search {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 28px;
        border-bottom: 1px solid #ddd;
        border-right: 1px solid #ddd;
    }

    .department-tree {
        position: relative;
        height: 490px;
        width: 100%;
        border-right: 1px solid #ddd
    }

    .form-warp-main {
        position: relative;
        height: 492px;
        width: 100%;
        padding-top: 28px
    }

    .employee-search {
        position: absolute;
        top: 0;
        left: 1px;
        width: 100%;
        height: 28px;
        border-bottom: 1px solid #ddd
    }

    .list {
        position: relative;
        height: 492px;
        width: 560px
    }

    .card-box {
        position: relative;
        float: left;
        width: 100px;
        height: 60px;
        border: 1px solid #ccc;
        background-color: #fff;
        border-radius: 3px;
        margin: 10px 0 0 10px;
        padding-left: 69px;
        overflow: hidden;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        -khtml-user-select: none;
        user-select: none;
        cursor: pointer
    }

    .card-box.active {
        border: 1px solid #ff5d5b;
        background: url(../../assets/img/selected_red.png) right top no-repeat
    }

    .card-box-img {
        position: absolute;
        left: 0;
        top: 0;
        width: 56px;
        height: 60px;
        line-height: 60px;
        padding-left: 5px;
        background-color: #ebebeb;
        border-right: 1px solid #ccc
    }

    .card-box-img img {
        border-radius: 45px;
        width: 50px;
        height: 50px;
        margin-top: 5px;
    }

    .card-box-content {
        padding: 6px 0
    }

    .card-box-content p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin: 0;
        font-size: 10px
    }

    .form-warp-right {
        position: absolute;
        top: 0;
        right: 0;
        height: 492px;
        width: 180px;
        border-left: 1px solid #ddd;
        padding-top: 28px;
        background-color: #fff;
        z-index: 10;
        transition: all 300ms;
        overflow-x: hidden;
        overflow-y: auto;
    }

    .form-warp-right.hide {
        width: 0px;
    }

    .form-warp-right-close {
        position: absolute;
        top: 7px;
        right: 4px;
        width: 12px;
        height: 13px;
        display: block;
        cursor: pointer
    }

    .form-warp-right-close:hover {
        background-position: 0 -12px
    }

    .form-warp-right-title {
        position: absolute;
        top: 0;
        right: 0;
        height: 28px;
        line-height: 27px;
        padding-left: 10px;
        width: 170px;
        border-bottom: 1px solid #ddd;
        cursor: pointer
    }

    .selected-list-warp {
        position: relative;
        height: 492px;
        width: 180px;
    }

    .selected-box {
        position: relative;
        width: 150px;
        height: 55px;
        border: 1px solid #ccc;
        border-radius: 4px;
        margin: auto;
        margin-top: 10px;
        padding: 5px 0 0 10px
    }

    .selected-box p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin: 0
    }

    .remove {
        position: absolute;
        top: 2px;
        right: 2px;
        width: 12px;
        height: 13px;
        display: block;
        cursor: pointer;
        opacity: 0.5
    }

    .remove:hover {
        opacity: 1
    }

    .selected-btn {
        position: absolute;
        top: 0;
        right: 1px;
        height: 100%;
        width: 80px;
        line-height: 27px;
        text-align: center;
        border-left: 1px solid #ddd;
        cursor: pointer;
        background-color: #eee;
        color: #666
    }

    .selected-btn:hover {
        color: #333
    }

    .form-control {
        border: 0;
        height: 100%;
    }

    .input-query {
        position: absolute;
        right: 146px;
        top: 5px;
        color: #ccc;
        font-size: 16px;
        cursor: pointer
    }

    .select-all {
        position: absolute;
        top: 0;
        right: 80px;
        height: 100%;
        width: 60px;
        line-height: 27px;
        text-align: center;
        border-left: 1px solid #ddd;
        cursor: pointer;
        background-color: #eee;
        color: #666
    }

    .span-ellipsis {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: block;
    }
</style>
